<template>
    <a-flex :vertical="layout_info_vertical" gap='small' >
        <a-card class="widget-1" :headStyle="{ height:'48px'}" :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px', paddingBottom: '5px'}">
            <template #title>
                <span>Precio del Servicio</span>
            </template>
            <a-flex align="center" justify="center" class="widget_service">
                <span style="font-weight: 400;">{{ my_service.total_amount}}</span>
                <span style="padding-left: 4px" ><DollarOutlined /></span>
            </a-flex>
        </a-card>
        <a-card class="widget-1" :headStyle="{ height:'48px'}" :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px', paddingBottom: '5px'}">
            <template #title>
                <span style="text-align: justify">Fecha de corte</span>
            </template>
            <a-flex align="center" justify="center" class="widget_service">
                <span style="padding-right: 4px"><CalendarOutlined /></span>
                <span style="font-weight: 400;">{{ formatDate(my_service.date_last_facturation, "DD-MM-YYYY") }}</span>
            </a-flex>
        </a-card>
    </a-flex>
    
</template>
<script>
import { formatDate }  from '@/plugins/odoo_table'
import { DollarOutlined, CalendarOutlined } from '@ant-design/icons-vue';
export default {
    components: {
        DollarOutlined, CalendarOutlined
    },
    props: {
        my_service: {
            type: Object,
            required: true
        },
        layout_info_vertical: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        formatDate
    }

}
</script>